export const balance = (data: any[], columns: number = 4) => {
  const offset = data.length % columns ? 1 : 0
  const height = (data.length - (data.length % columns)) / columns + offset
  const unbalanced = [...data]
  const balanced = []
  while (unbalanced.length) balanced.push(unbalanced.splice(0, height))
  return balanced
}
